import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import { useOnMount } from './useOnMount';
export function useSubscribeOnMount(param, callback) {
    let { subscribe, unsubscribe } = param;
    useOnMount(()=>{
        const id = generateUniqueId('observable-callback');
        subscribe({
            id,
            callback
        });
        return ()=>unsubscribe(id);
    });
}
